import { formatBRL } from "../../utils/currency";
import { Passagem as IPassagem } from "../../utils/interfaces";
import { shouldHideFeeDetails, useShouldShowProvider } from "../../libs/auth";
import { formatProvider } from "../../utils/provider";

import {
  Popover,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
  Box,
  Flex,
  Td,
  Text,
  Tr,
  useDisclosure,
  PopoverTrigger,
  Divider,
} from "@chakra-ui/react";

interface Props {
  passagem: IPassagem;
  onLayout: (passagem: IPassagem) => void;
}

export function Passagem({ passagem, onLayout }: Props) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const hideFeeDetails = shouldHideFeeDetails();
  const showProvider = useShouldShowProvider();

  return (
    <>
    <Tr
      onClick={() => onLayout(passagem)}
      cursor={"pointer"}
      key={`tr-ida-${passagem.servico}`}
      _hover={{ backgroundColor: "#ffcd85", color: "#1e1810" }}
      className="group"
    >
      <Td
        px={1}
        py={0}
        textAlign={"center"}
        _groupHover={{ backgroundColor: "#ffcd85", color: "#1e1810" }}
      >
        <Box>
          <Text>{passagem.saidaHora}</Text>
            <Text borderRadius={'sm'} bg={'blue.100'} textColor={'blue.900'} p={0} as={'span'} fontSize={'x-small'}>
              {passagem.viacao.documento_preferencial_label}
            </Text>
        </Box>
      </Td>
      <Td
        px={1}
        py={0}
        textAlign={"center"}
        _groupHover={{ backgroundColor: "#ffcd85", color: "#1e1810" }}
        colSpan={2}
      >
        <Box>
          <Text fontSize={'x-small'}>{passagem.origemLabel}</Text>
          <Text fontSize={'x-small'}>{passagem.destinoLabel}</Text>
        </Box>
      </Td>
      <Td
        px={1}
        py={0}
        textAlign={"center"}
        _groupHover={{ backgroundColor: "#ffcd85", color: "#1e1810" }}
      >
        {passagem.classe}
      </Td>
      <Td
        px={1}
        py={0}
        textAlign={"center"}
        _groupHover={{ backgroundColor: "#ffcd85", color: "#1e1810" }}
        onMouseEnter={hideFeeDetails ? undefined : onOpen}
        onMouseLeave={hideFeeDetails ? undefined : onClose}
      >
        {hideFeeDetails ? (
          <Text as={'span'}>{formatBRL(passagem.preco)}</Text>
        ) : (
        <Popover
          returnFocusOnClose={false}
          isOpen={isOpen}
          onClose={onClose}
          placement="end-start"
          
          closeOnBlur={false}
          key={`popover-${passagem.servico}`}
        >
          <PopoverTrigger>
            <Text as={'span'}>{formatBRL(passagem.preco)}</Text>
          </PopoverTrigger>
          <PopoverContent bg={'black'} color="white">
            <PopoverArrow />
            <PopoverBody>
              <Flex alignItems={'end'} justifyContent={'space-between'}>
                <Text>Preço Base</Text>
                <Divider mb={1} w={'full'} borderBottomColor={'white'} borderBottomStyle={'dotted'} borderBottomWidth={'1px'}></Divider>
                <Text>{formatBRL(passagem.precoBase)}</Text>
              </Flex>
              <Flex alignItems={'end'} justifyContent={'space-between'}>
                <Text>Viagem premiada</Text>
                <Divider mb={1} w={'full'} borderBottomColor={'white'} borderBottomStyle={'dotted'} borderBottomWidth={'1px'}></Divider>
                <Text>{formatBRL(passagem.valorViagemPremiada ?? passagem.valorSeguro)}</Text>
              </Flex>
              <Flex justifyContent={'space-between'} alignItems={'end'}>
                <Text>Conveniência Agência</Text>
                <Divider mb={1} w={'full'} borderBottomColor={'white'} borderBottomStyle={'dotted'} borderBottomWidth={'1px'}></Divider>
                <Text>{formatBRL(Number(passagem.taxaAgencia))}</Text>
              </Flex>
              <Flex justifyContent={'space-between'} alignItems={'end'}>
                <Text>Conveniência Gopass</Text>
                <Divider mb={1} w={'full'} borderBottomColor={'white'} borderBottomStyle={'dotted'} borderBottomWidth={'1px'}></Divider>
                <Text>{formatBRL(Number(passagem.taxaGoPass))}</Text>
              </Flex>
              <Flex justifyContent={'space-between'} alignItems={'end'}>
                <Text>Total</Text>
                <Divider mb={1} w={'full'} borderBottomColor={'white'} borderBottomStyle={'dotted'} borderBottomWidth={'1px'}></Divider>
                <Text>{formatBRL(passagem.preco)}</Text>
              </Flex>
            </PopoverBody>
          </PopoverContent>
        </Popover>
        )}
        
      </Td>
      <Td
        px={1}
        py={0}
        textAlign={"center"}
        _groupHover={{ backgroundColor: "#ffcd85", color: "#1e1810" }}
      >
        {passagem.livres}
      </Td>
      <Td
        px={1}
        py={0}
        textAlign={"center"}
        _groupHover={{ backgroundColor: "#ffcd85", color: "#1e1810" }}
      >
         <Box>
          <Text> {passagem.chegadaDia} {passagem.chegadaHora}</Text>
          {passagem.conexoes.length > 0 && (
            <Text borderRadius={'sm'} bg={'purple.100'} textColor={'purple.900'} p={0} as={'span'} fontSize={'x-small'}>{passagem.conexoes.length === 1 ? '1 conexão' : `${passagem.conexoes.length} conexões`}</Text>

          )}
        </Box>
      </Td>
      <Td
        px={1}
        py={0}
        textAlign={"center"}
        _groupHover={{ backgroundColor: "#ffcd85", color: "#1e1810" }}
      >
        <Text>{passagem.viacao.nome}</Text>
      </Td>
      {showProvider && <Td
        px={1}
        py={0}
        textAlign={"center"}
        _groupHover={{ backgroundColor: "#ffcd85", color: "#1e1810" }}
      >
        {formatProvider(passagem.adaptador, passagem.provedorWebviagem)}
      </Td>}
    </Tr>
    </>
  );
}
